<template>
  <div class="substitution">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">REGION SKÅNES UTBYTESLISTA</h1>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-form-input ref="searchInput" v-model="search"
                type="text"
                autocapitalize="off"
                autocorrect="off"
                spellcheck="false"
                placeholder="Sök i dokumenttext" class="drug-search" @keydown.enter.exact="$refs.pdfComp.gotoMatch(1)" @keydown.shift.enter="$refs.pdfComp.gotoMatch(-1)" @keydown.esc="search = ''" />
            </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container fluid>
      <b-row>
        <b-col>
          <!-- <pdf-viewer ref="pdfComp" src="/utbyteslista-lakemedel-pa-rekvisition.pdf" :scale="1.3" :searchString="this.search" /> -->
          <pdf-viewer ref="pdfComp" pdfDbEntryKey="substitutionsPdf" :scale="0.74" :searchString="this.search" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getAll, updateContent } from '../store/actions'
import { clickTracker } from '@/services/helpers'
import PdfViewer from '../components/PdfViewer'

export default {
  name: 'Substitution',
  data () {
    return {
      search: '',
      filter: 'Generika',
      showDialog: false
    }
  },
  mounted () {
    getAll(this.$store)
    clickTracker('keyExchangeListSkane')
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    generalInstructionsGen () {
      let item = this.$store.getters.contentByKey('SubstitutionGen')
      if (!item) return ''
      return item || ''
    },
    generalInstructionsAn () {
      let item = this.$store.getters.contentByKey('SubstitutionAn')
      if (!item) return ''
      return item || ''
    }
  },
  methods: {
    changeCategory (category) {
      this.filter = category
    },
    applyTextEdit () {
      if (this.filter === 'Generika') {
        this.save(this.generalInstructionsGen)
      } else {
        this.save(this.generalInstructionsAn)
      }
    },
    save (content) {
      updateContent(this.$store, content)
    }
  },
  components: {
    'pdf-viewer': PdfViewer
  }
}
</script>
<style scoped lang="scss">
h1, h2 {
  font-weight: normal;
}

h4 {
  margin-bottom: 0;
}

i.fa {
  color: $orange;
  margin-top: 8px;
}

.drug-search {
  margin: 20px 0;
  padding: 10px;
}

.section-name {
  color: white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 170px;
  width: 100%;
  background-image: url('../assets/substitution-background.jpg');
  background-position-y: bottom;
  background-size: cover;
}

.container-fluid {
  padding-left:0px;
  padding-right:0px;
}

.general-info {
  padding: 10px 0;
}

</style>
